// Example.js
import React, { useState, useEffect } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Fireworks } from './components/animations/FireworksAnimator';

const ExampleComponent = () => {
  const [showFireworks, setShowFireworks] = useState(false);
  
  // This simulates your condition being met automatically
  useEffect(() => {
    // For demo purposes - in real use, this would be your condition
    setShowFireworks(true);
    
    // Reset after animation completes (optional)
    const timer = setTimeout(() => {
      setShowFireworks(false);
    }, 6000); // Slightly longer than animation duration to ensure completion
    
    return () => clearTimeout(timer);
  }, []);
  
  // Manual trigger function
  const triggerFireworks = () => {
    setShowFireworks(true);
    
    // Reset after animation completes
    setTimeout(() => {
      setShowFireworks(false);
    }, 6000);
  };

  return (
    <Box sx={{ position: 'relative', height: '100vh', width: '100%'}}>
      {/* Background content */}
      <Box sx={{ 
        position: 'absolute', 
        top: 0, 
        left: 0, 
        width: '100%', 
        height: '100%', 
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        p: 3,
        color: 'white',
        textAlign: 'center'
      }}>
        <Typography variant="h3" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
          Fireworks Animation Demo
        </Typography>
        
        <Typography variant="h6" sx={{ maxWidth: '600px', mb: 6 }}>
          This example demonstrates the fireworks animation when a goal is completed.
          The animation includes realistic rockets that launch upward and explode into
          colorful particles.
        </Typography>
        
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <Button 
            variant="contained" 
            color="primary"
            size="large"
            onClick={triggerFireworks}
            sx={{ 
              bgcolor: 'primary.main', 
              px: 4, 
              py: 1.5,
              fontSize: '1.1rem',
              borderRadius: 2
            }}
          >
            Trigger Fireworks
          </Button>
        </Stack>
      </Box>
      
      {/* The fireworks component will render when showFireworks is true */}
      <Fireworks trigger={showFireworks} />
    </Box>
  );
};

export default ExampleComponent;